import { Modal } from "react-bootstrap";
import { BiError } from "react-icons/bi";
import { useLanguage } from "../Translations/LenguageContext";

const ErrorDeploymentModal = ({ show, handleClose }) => {
    const {t} = useLanguage()
    return (
        <Modal show={show} onHide={handleClose} centered className="mcp_modal_custom">
            <div className="modal_header">
                <p className="modal_header_title">{t.abilities.deployment_error} <BiError /></p>
            </div>
            <div className="modal_main_cont">
                <div className="info_mcp_modal_cont">
                    <div className="persona_reg">
                        <div className="label_input">
                            <div className="warning_message_cont">
                                <p className="warning_message_description">
                                    {t.abilities.deployment_err_subtitle}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal_footer">
                <span></span>
                <div className="modal_footer_btn_cont">
                    <button className="modale_close_btn" onClick={handleClose}>
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ErrorDeploymentModal;